// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__EVwvO","telegram":"Footer_telegram__gCD2z","whatsapp":"Footer_whatsapp__E2Jg-"};